module.exports = __webpack_public_path__ + "static/calciumImaging-8269bf6bfe74e38c9f9649ae5d229dc2.png";